<i
    *ngIf="!useFontAwesome()"
    class="resource-icon"
    [ngStyle]="{'background-color': getColor()}"
    [ngClass]="getShapeClass()"
    nz-tooltip
    [nzTooltipTitle]="data.tooltipText"></i>

<fa-icon
    #fontawesomeicon
    *ngIf="useFontAwesome()"
    [style.color]="getColor() + '!important'"
    [ngClass]="getShapeClass()"
    nz-tooltip
    [nzTooltipTitle]="data.tooltipText"
    [icon]="getFontAwesomeIconName()"></fa-icon>
